import { useEffect } from "react";

export const KshanbhangurPremsari = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div
                className="modal"
                style={{
                    display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%",
                    height: "100%", overflowY: "auto", // Enable scrolling for the modal
                    zIndex: 1050,

                }}
            >
                <div
                    className="modal-content"
                    style={{
                        padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                        maxHeight: "95vh", // Limit the modal height to viewport
                        overflowY: "auto", // Enable content scrolling within the modal
                    }}
                >
                    <div className="img-fluid mb-4">
                        <picture>
                            <img src="/media/poemsmar/kshanbhar-premsari.jpg" alt=" क्षणभंगुर प्रेमसरी | Lone Wolf writes" style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray", }} /></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>क्षणभंगुर प्रेमसरी</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        पावसाच्या सरीप्रमाणे<br />
                        आयुष्यात ती आली,<br />
                        पाण्याच्या प्रवाहागत<br />
                        निघुनी ती गेली.<br />
                        प्रेमात वाहण्याची<br />
                        चूक मोठी केली,<br />
                        पापण्या या ओल्या<br />
                        करुनि ती गेली.<br />
                        <br />
                        प्रेमनौका त्या पाण्यावर<br />
                        कधीच ना वाहिली,<br />
                        प्रेमाची पाटी मात्र<br />
                        कोरीच राहिली.<br />
                        ती गेलेल्या वाटेवर<br />
                        वाट किती पहिली,<br />
                        नजरेचीही तहान<br />
                        अतृप्तच राहिली.<br />
                        <br />
                        प्रयत्नांची पराकाष्ठा<br />
                        किती मी केली,<br />
                        पण काही केल्या ती<br />
                        परत नाही आली.<br />
                        ती गेल्यावर माझी<br />
                        दैना वाईट झाली,<br />
                        तरी सोबतीला माझ्या<br />
                        ती येथे ना राहिली.<br />
                        <br />
                        अथांग प्रेमसागराप्रमाणे<br />
                        अथांग प्रेम आपुले,<br />
                        जीवाचे रान झाले<br />
                        तरीही मी ते जपले.<br />
                        आश्रू किती थांबविले<br />
                        पण ते हि ना जमले,<br />
                        सुखकर क्षण आयुष्यात<br />
                        मग कायमचेच लपले.<br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }} >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
